import * as types from '../constants/actionTypes';
import { signalRUrl } from '../constants/config';
import {getToken} from '../utils/tokenUtil'


  import {
    addMessageReply,
    indicateNewMessage,
    appendNewMessageToListView,
    deleteMessageReply,
    fixMessage,
    updateGlobalNewMessageCount
  } from './messageActions';




function changeStatus(status) {
    return {
        type: types.CHANGE_STATUS,
        status: status
    }
}

function addLogEvent(event) {
    return {
        type: types.ADD_LOG_EVENT,
        log: event
    }
}


var connection = null;
var connectionAttempts = 0;
var reconnectIntervalFn = null;


export function initializeHub() {

    return (dispatch, getState) => {

        try{
            connection = new window.signalR.HubConnectionBuilder()
                            .withUrl(signalRUrl, { accessTokenFactory: () => getToken() })
                            .withAutomaticReconnect()
                            .configureLogging(window.signalR.LogLevel.Information)
                            .build();

            dispatch(addLogEvent("Starting SignalR Connection."))
            dispatch(startConnection());
        }
        catch(err){
        }
    }
  }

  function startConnection(){

    return (dispatch, getState) => {

        var events = [
            {
            eventName: 'addNewMessageToPage',
            eventFunction: function(message) {

                dispatch(addLogEvent('SignalR message received: addNewMessageToPage'));

                const _message = getState().thisApp.messaging.message;
                const showMessage = getState().thisApp.messaging.showMessage;


                if(showMessage && _message && (_message.SystemMessageLogID === message.SystemMessageLogID)) {
                    dispatch(addMessageReply(message));

                    var element = document.getElementById("endOfChat");
                    if(element) {
                      //uses smoothscrolling-polyfill plugin, maths out to just above the chat input once user sends message and keyboard collapses.
                      if(window.device && window.device.platform.toLowerCase() === 'ios'){
                        // window.scrollTo({behavior:"smooth", top:(element.offsetTop - window.innerHeight)});
                        window.scrollTo(0,(element.offsetTop - window.innerHeight));
                      }
                      else {       
                        element.scrollIntoView({behavior:"smooth", block:"end"});
                      }
                    }
                    //if(window.isMobile)  -> dont need to do this for browsers.
                }


                if(message.Sender !== 0) {
                // do not append after hours replies to the messages list view.
                dispatch(appendNewMessageToListView(message));
                }

                // we still want to increament new message alerts even when viewing another message.
                if(!showMessage || (showMessage && _message && (_message.SystemMessageLogID !== message.SystemMessageLogID))) {
                dispatch(indicateNewMessage(message));
                dispatch(updateGlobalNewMessageCount());
                }

            }
            },
            {
            eventName: 'fixMessage',
            eventFunction: function(message) {

                const _message = getState().thisApp.messaging.message;
                const showMessage = getState().thisApp.messaging.showMessage;
                if(showMessage && _message && (_message.SystemMessageLogID === message.SystemMessageLogID)) {
                dispatch(fixMessage(message));
                }
            }
            },
            {
            eventName: 'deleteMessageReply',
            eventFunction: function(reply) {

                const _message = getState().thisApp.messaging.message;
                const showMessage = getState().thisApp.messaging.showMessage;
                if(showMessage && _message && (_message.SystemMessageLogID === reply.SystemMessageLogID)) {
                dispatch(deleteMessageReply(reply));
                }
            }
            }
        ];


        for(var i = 0; i < events.length; i++){
            connection.on(events[i].eventName, events[i].eventFunction);
        }

        async function start() {
            try {
                await connection.start();
                // console.log("connected");
            } catch (err) {
                console.log(err);
                setTimeout(() => start(), 5000);
            }
        };

        start()
        // console.log(connection)
        
        connection.onclose(async () => {
            await start();
        });
    }
  }




// WEBPACK FOOTER //
// ./src/actions/signalrActions.js